import { render } from "./IconUTurnRight.vue?vue&type=template&id=143d4e9c"
import script from "./IconUTurnRight.vue?vue&type=script&lang=js"
export * from "./IconUTurnRight.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__